// extracted by mini-css-extract-plugin
module.exports = {"hiddenIframe":"IframeUtil-hashed__hiddenIframe__3StOE"};